import React from "react"
import { Helmet } from "react-helmet"

type JsonLdProps = {
  data: object | object[]
}

export const JsonLd = ({ data }: JsonLdProps) => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(data)}</script>
  </Helmet>
)
